import * as f from "react";
function o(s, u, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(c) {
    if (s == null || s(c), t === !1 || !c.defaultPrevented)
      return u == null ? void 0 : u(c);
  };
}
function m(s) {
  const u = f.useRef(s);
  return f.useEffect(() => {
    u.current = s;
  }), f.useMemo(() => (...t) => {
    var e;
    return (e = u.current) == null ? void 0 : e.call(u, ...t);
  }, []);
}
var p = globalThis != null && globalThis.document ? f.useLayoutEffect : () => {
};
export {
  m as a,
  o as c,
  p as u
};
//# sourceMappingURL=index.BMovUuXF.js.map
